/** Allineato a backend/src/config/aiDefaults.ts — LFM2.5-8B-A1B su Ollama. */
export const DEFAULT_AI_MODEL = 'lfm2.5:8b';
export const SUGGESTED_AI_MODELS = ['lfm2.5:8b', 'lfm2.5:8b-a1b-q4_K_M'];
